// Textes traduits, fournis par theme.liquid via les attributs data-* du <script>
// (déclarés dans locales/*.json pour être détectés par Translate & Adapt).
// Le texte français sert de secours si les attributs ne sont pas présents.
const HINT_TEXT =
  document.currentScript?.dataset.hintText ||
  "Merci de sélectionner votre choix ci-dessus (même s'il est déjà affiché) pour pouvoir l'ajouter au panier.";
const ERROR_TEXT =
  document.currentScript?.dataset.errorText ||
  "Veuillez faire votre sélection ci-dessus avant d'ajouter au panier.";

// On garde la trace des choix du client en dehors du DOM (dans une variable JS),
// car le thème redessine (morph) le sélecteur de variantes à chaque changement,
// ce qui effacerait un simple attribut posé sur l'élément HTML.
const selectedOptionsBySection = new Map(); // sectionId -> Set des noms d'options choisies

function getRequiredNames(picker) {
  const names = new Set();
  picker.querySelectorAll('fieldset').forEach((fs) => {
    const name = fs.querySelector('input')?.dataset.optionName;
    if (name) names.add(name);
  });
  picker.querySelectorAll('select').forEach((sel) => {
    const name = sel.options[0]?.dataset.optionName;
    if (name) names.add(name);
  });
  return names;
}

function isComplete(sectionId, requiredNames) {
  const chosen = selectedOptionsBySection.get(sectionId) || new Set();
  return Array.from(requiredNames).every((name) => chosen.has(name));
}

// Ajoute (ou remet à jour) le texte d'avertissement sous le sélecteur.
// Appelée aussi après chaque "morph" du thème, car celui-ci peut supprimer le texte injecté.
function ensureHint(picker) {
  const sectionId = picker.dataset.sectionId;
  const requiredNames = getRequiredNames(picker);
  if (requiredNames.size === 0) return; // produit à variante unique : rien à afficher

  const form = picker.querySelector('form');
  if (!form) return;

  let hint = form.querySelector(':scope > .require-selection-hint');
  if (!hint) {
    hint = document.createElement('p');
    hint.className = 'require-selection-hint';
    hint.style.cssText =
      'font-size: 0.85em; margin-top: 8px; color: var(--color-foreground-secondary, inherit);';
    hint.textContent = HINT_TEXT;
    form.appendChild(hint);
  }

  hint.style.display = isComplete(sectionId, requiredNames) ? 'none' : '';
}

// Initialisation : ajoute le texte sur tous les sélecteurs présents au chargement,
// et surveille les futurs redessins (morph) pour le remettre en place si besoin.
document.querySelectorAll('variant-picker').forEach((picker) => {
  ensureHint(picker);
  new MutationObserver(() => ensureHint(picker)).observe(picker, { childList: true, subtree: true });
});

document.addEventListener('change', (event) => {
  const picker = event.target.closest('variant-picker');
  if (!picker) return;

  const sectionId = picker.dataset.sectionId;
  if (!sectionId) return;

  let optionName;
  if (event.target.tagName === 'SELECT') {
    optionName = event.target.selectedOptions[0]?.dataset.optionName;
  } else {
    optionName = event.target.dataset.optionName;
  }

  if (optionName) {
    if (!selectedOptionsBySection.has(sectionId)) {
      selectedOptionsBySection.set(sectionId, new Set());
    }
    selectedOptionsBySection.get(sectionId).add(optionName);
  }

  ensureHint(picker);
});

document.addEventListener(
  'click',
  (event) => {
    const button = event.target.closest('button[name="add"]');
    if (!button) return;

    const formComponent = button.closest('product-form-component');
    const sectionId = formComponent?.dataset.sectionId;
    if (!sectionId) return;

    const picker = document.querySelector(`variant-picker[data-section-id="${sectionId}"]`);
    if (!picker) return;

    const requiredNames = getRequiredNames(picker);
    if (requiredNames.size === 0) return; // produit à variante unique : rien à exiger
    if (isComplete(sectionId, requiredNames)) return; // tout a été choisi, on laisse faire

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    const errorEl = formComponent.querySelector('[ref="addToCartTextError"]');
    if (errorEl) {
      errorEl.classList.remove('hidden');
      errorEl.style.setProperty('color', '#d82c0d', 'important');
      errorEl.textContent = ERROR_TEXT;
    } else {
      alert(ERROR_TEXT);
    }

    picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
  },
  true
);